










import AppSvgIcon from "@/uikit/components/AppSvgIconNew";
export default {
  name: "AddEditWorkPlaceHeader",
  components: {
    AppSvgIcon
  },
  props: {
    title: String
  },
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/work/components/AddEditWorkPlaceHeader.vue